module.exports = __webpack_public_path__ + "static/media/img-5.a0c4b593.jpg";